// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + (chunkId === 781 ? "npm.microservices.gantt" : chunkId) + "." + {"237":"8db6b1fb486881bd7f7d","270":"50d7cc468c12074aebd2","334":"9a881ce5db6deb07d93b","357":"4edb080176d0dab4dced","768":"c14a609781d9c24aab83","781":"7864eff1c33ce28e2ea0"}[chunkId] + ".bundle.js";
};